import { IconButton } from '@/app/components/buttons/IconButton';
import ChevronRightIcon from '/public/icons/chevron-right-pagination.svg';
import { useMemo } from 'react';
import { cn } from '@/utils/сn';
import { formatCalendarNavTitle } from '../../utils/formatCalendarNavTitle';
import type { CalendarViewMode } from '@/types/calendarTypes';

interface NextUpNavigationProps {
  onPrevious: () => void;
  onNext: () => void;
  view: CalendarViewMode;
  titleAnchor: Date;
  weekStart: Date;
  weekEnd: Date;
  isWidget: boolean;
}

export function NextUpNavigation({ onPrevious, onNext, view, titleAnchor, weekStart, weekEnd, isWidget }: NextUpNavigationProps) {
  const navTitle = useMemo(
    () => formatCalendarNavTitle(view, titleAnchor, weekStart, weekEnd),
    [view, titleAnchor, weekStart, weekEnd]
  );
  
  return (
    <div className={cn('items-center gap-2 w-full justify-between px-4', {
      'md:hidden flex': isWidget,
      'hidden': !isWidget,
    })}>
      <IconButton size="medium" icon={<ChevronRightIcon className="w-4 h-4 min-w-4 min-h-4 text-blue-300 rotate-180" />} aria-label="Previous" onClick={onPrevious} />
      <p className="font-inter text-sm font-semibold text-blue-300 truncate">{navTitle}</p>
      <IconButton size="medium" icon={<ChevronRightIcon className="w-4 h-4 min-w-4 min-h-4 text-blue-300" />} aria-label="Next" onClick={onNext} />
    </div>
  );
}